import type { OrderStatus } from './types';

/**
 * The semantic colour of each order status in the Figma design (« Souk 2.0 »): blue for an order received or
 * prepared, blue while it is being prepared or on its way, amber while its payment is pending or a return asked for,
 * green once delivered, red when it was cancelled or failed, grey once it left the flow (returned, refunded). The status
 * pill, the dashboard's order-status panel and the order list's filters all read it from here.
 *
 * `Record<OrderStatus, …>`: a status this map does not colour fails to COMPILE.
 */
export type StatusTone = 'brand' | 'blue' | 'amber' | 'green' | 'red' | 'neutral';

export const STATUS_TONE_FIGMA: Record<OrderStatus, StatusTone> = {
  ORDER_CREATED: 'brand',
  PAYMENT_PENDING: 'amber',
  PAYMENT_CONFIRMED: 'amber',
  PAYMENT_FAILED: 'red',
  PROCESSING: 'blue',
  PACKED: 'brand',
  SHIPPED: 'blue',
  DELIVERED: 'green',
  DELIVERY_FAILED: 'red',
  CANCELLED: 'red',
  RETURN_REQUESTED: 'amber',
  RETURNED: 'neutral',
  REFUNDED: 'neutral',
  PARTIALLY_REFUNDED: 'neutral',
};

/** Orders whose story is over (« Terminées » in the dashboard's order-status panel). */
export const FINISHED_STATUSES: ReadonlySet<OrderStatus> = new Set<OrderStatus>([
  'DELIVERED',
  'CANCELLED',
  'RETURNED',
  'REFUNDED',
  'PARTIALLY_REFUNDED',
]);

/** Literal fill classes per tone (Tailwind's JIT and the stylesheet only see what is written out). */
export const TONE_FILL: Record<StatusTone, string> = {
  brand: 'sk-fill-brand',
  blue: 'sk-fill-blue',
  amber: 'sk-fill-amber',
  green: 'sk-fill-green',
  red: 'sk-fill-red',
  neutral: 'sk-fill-neutral',
};
